import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {CustomSocket} from "./CustomSocket";
import React, {memo} from "react";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import Divider from "./Divider";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  width: 100%;
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0px;
`;

const StyledScoreRemoveContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 64px;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-top: 8px;
`;

const StyledKeywordsControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  margin-left: ${props => props.$isNodeCollapsed ? NESTED_NODE_HORIZONTAL_MARGIN : "8px"};
`;

const StyledKeywordsControlWrapperDiv = styled.div`
  width: 100%;
  > div {
    width: 100% !important;
    height: ${props => props.$isNodeCollapsed ? "38px" : "100%"};
    flex: 1 !important;
  }
`;

const StyledSocketContainerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  width: 0px;
`;

const VoiceAnswers = ({controls, outputs, bindSocket, bindControl, isNodeCollapsed}) => {
    let nestedNodes = [];
    outputs.forEach(output => {
        const answerUUID = output.key.split('_')[0];
        const answerRemoveButtonControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVoiceAnswerRemoveButtonKey(answerUUID)));
        const answerKeywordsControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVoiceAnswerKeywordKey(answerUUID)));
        const answerScoreControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVoiceAnswerScoreKey(answerUUID)));
        nestedNodes.push({key: answerUUID, removeButtonControl: answerRemoveButtonControl, scoreControl: answerScoreControl, keywordControl: answerKeywordsControl, outputControl: output})
    });

    return (
        <div>
            {nestedNodes.map((nestedNode, index) => (
                <div key={nestedNode.key}>
                    <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                        {!isNodeCollapsed &&
                            <StyledScoreRemoveContainerDiv>
                                {/** SCORE CONTROL */}
                                <Control key={nestedNode.scoreControl.key}
                                         control={nestedNode.scoreControl}
                                         innerRef={bindControl}/>

                                {/** REMOVE BTN */}
                                <StyledRemoveButtonContainerDiv>
                                    <Control key={nestedNode.removeButtonControl.key}
                                             control={nestedNode.removeButtonControl}
                                             innerRef={bindControl}/>
                                </StyledRemoveButtonContainerDiv>
                            </StyledScoreRemoveContainerDiv>
                        }

                        {/** KEYWORDS CONTROL */}
                        <StyledKeywordsControlContainerDiv $isNodeCollapsed={isNodeCollapsed}>

                            {/** TODO: */}
                            <StyledKeywordsControlWrapperDiv $isNodeCollapsed={isNodeCollapsed}>
                                <Control key={nestedNode.keywordControl.key}
                                         control={nestedNode.keywordControl}
                                         innerRef={bindControl}/>
                            </StyledKeywordsControlWrapperDiv>

                        </StyledKeywordsControlContainerDiv>

                        {/** SOCKET */}
                        <StyledSocketContainerDiv>
                            <CustomSocket type="output" socket={nestedNode.outputControl.socket}
                                          io={nestedNode.outputControl} innerRef={bindSocket}/>
                        </StyledSocketContainerDiv>
                    </StyledNestedNodeDiv>
                    {!(isNodeCollapsed && index === nestedNodes.length - 1) && <Divider height={1}/>}
                </div>
            ))}
        </div>
    );
}

export default memo(VoiceAnswers)